<template>
  <div class="page-content">
    <page-template
      class="info-container"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
    ></page-template>
    <el-dialog
      title="订单详情"
      :visible.sync="billShow"
      :close-on-click-modal="false"
    >
      <div class="detail-style">
        <table class="table-info">
          <thead>
            <tr>
              <td>商品名称</td>
              <td>数量</td>
              <td>金额</td>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in tableData" :key="index">
            <td>{{item.name}}</td>
            <td>{{item.num}}</td>
            <td>{{item.totalPrice}}</td>
          </tr>
          </tbody>
        </table>
        <div>
          <div class="flex-between">
            <div>商品合计</div>
            <div>{{detailForm.productPrice}}</div>
          </div>
          <div class="flex-between">
            <div>包装费</div>
            <div>{{detailForm.mealFee}}</div>
          </div>
          <div class="flex-between">
            <div>优惠合计</div>
            <div>{{detailForm.discountPrice}}</div>
          </div>
          <div class="flex-between">
            <div>预计收入</div>
            <div>{{detailForm.merchantPrice}}</div>
          </div>
          <div class="flex-between">
            <div>实际支付</div>
            <div>{{detailForm.price}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
// import listBillView from "@/components/template/listBillView"
import api from '@/config/api';
import userPower from '@/mixin/userPower';

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
    // listBillView
  },
  data() {
    return {
      tableData:[],
      billShow:false,
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "订单编号", prop: "orderNo", type: "input", isFuzzy: true, placeholder: "请输入订单编号"},
        ],
        complex: [
          {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          {
            label: "门店名称",
            prop: "subStoreId",
            type: "select",
            data: [],
            labelKey:'storeName',
            uniqueKey:'storeId',
            span: 8,
            url: api.takeout.takeoutStore,
          },
          {
            label: "下单平台",
            prop: "fromType",
            type: "select",
            span: 8,
            data:  this.$utils.getCacheStatus('cdOrder.fromType'),
          },
          {
            label: "订单类型",
            prop: "businessType",
            type: "select",
            span: 8,
            data:  this.$utils.getCacheStatus('cdOrder.businessType'),
          },
          {label: "收货人姓名", prop: "name", type: "input", placeholder: "请输入姓名"},
        ]
      },
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
          {
            label: '订单号',
            prop: 'orderNo',
            width: '230',
            align: 'center',
            callback: this.goOrderDetail,
          },
          {label: '下单渠道', prop: 'fromType', width: '150', align: 'center',enumData: this.$utils.getCacheStatus('cdOrder.fromType')},
          {label: '下单时间', prop: 'orderTime', width: '150', align: 'center'},
          {label: '订单类型', prop: 'businessType', width: '150', align: 'center',enumData: this.$utils.getCacheStatus('cdOrder.businessType')},
          {label: '配送方式', prop: 'orderType', width: '100', align: 'center',enumData: this.$utils.getCacheStatus('cdOrder.orderType')},
          {label: '订单总价', prop: 'originprice', width: '100', align: 'center'},
          {label: '优惠金额', prop: 'discountPrice', width: '100', align: 'center'},
          {label: '实付金额', prop: 'price', width: '100', align: 'center'},
          {label: '预计入账金额', prop: 'merchantPrice', width: '150', align: 'center'},
          {label: '收货人姓名', prop: 'name', width: '120', align: 'center'},
          {label: '手机号', prop: 'phone', width: '100', align: 'center'},
          {label: '收货地址', prop: 'address', width: '100', align: 'center'},
          {label: '退货原单号', prop: 'orderNo', width: '230', align: 'center'},
          {label: '取消原因', prop: 'cancelReason', width: '100', align: 'center',enumData: this.$utils.getCacheStatus('cdOrder.cancelReason')},
          {label: '备注', prop: 'remarks', width: '100', align: 'center'},
        ],
        url: api.takeout.cdOrder
      },
      detailForm:{
        productPrice:'',//商品合计
        mealFee:'',//包装费
        discountPrice:'',//优惠合计
        merchantPrice:'',//预计收入
        price:'',//实际支付
      }
    };
  },
  created() {
    // this.setStore(this.searchOptions.complex);
  },
  methods: {
    goOrderDetail(row) {
      this.billShow = true
      this.$axios.fetchGet(api.takeout.cdOrder+'?id='+row.id,{}).then(res=>{
        if(res.code ==200 && res.data){
          this.detailForm= {
            productPrice:res.data.productPrice,//商品合计
            mealFee:res.data.mealFee,//包装费
            discountPrice:res.data.discountPrice,//优惠合计
            merchantPrice:res.data.merchantPrice,//预计收入
            price:res.data.price,//实际支付
          }
          // 商品信息
          this.$axios.fetchPost(api.takeout.cdOrderGoods+'/list',{orderId:res.data.orderId}).then(res=>{
            this.tableData= res.data
          })
        }
      })
    },
  }
};
</script>

<style scoped>
.info-container{
  padding-top:0;
}
.detail-style{
  padding:0 50px;
}
.detail-style .table-info{
  width:100%;
  border-bottom:1px dashed #999;
}
.detail-style .table-info thead{
  border-top:1px dashed #999;
  border-bottom:1px dashed #999;
}
.detail-style .table-info tr{
  height:30px;
}
.detail-style .flex-between{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/page/takeOut/order.vue